import { Transforms } from 'slate';
import { HistoryEditor } from 'slate-history';
import * as serializer from 'basic-editor-value-serializer';
import { cloneNode as cloneChild } from '../duplicate';

export function cloneNode(node) {
  return serializer.utilities.node.layout.cloneNode(node, cloneChild);
}

export function duplicate(editor, node, path) {
  const cloned = cloneChild(serializer.utilities.node.layout.cloneNode(node));

  HistoryEditor.withNewBatch(editor, function insertDuplicate() {
    Transforms.insertNodes(editor, cloned, { at: path });
  });
}
